import React, { useState, useEffect } from "react";
import { DateTime } from "luxon";
function Clock() {
  const [date, setDate] = useState(DateTime.now().toFormat("t"));

  function refreshClock() {
    setDate(DateTime.now().toFormat("t"));
  }
  useEffect(() => {
    const timerId = setInterval(refreshClock, 1000);
    return function cleanup() {
      clearInterval(timerId);
    };
  }, []);
  return <>{date}</>;
}
export default Clock;
